<div class="status-select-wrapper">
  <button
    type="button"
    class="select-trigger"
    [class.disabled]="disabled()"
    [disabled]="disabled()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggle()">
    <mtm-status-badge [label]="selectedLabel()" [colorScheme]="selectedOption().colorScheme" />
  </button>

  <ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="[
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 4 },
      { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -4 },
    ]"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (overlayOutsideClick)="close()"
    (overlayKeydown)="onOverlayKeydown($event)"
    (detach)="close()">
    <div class="dropdown-panel">
      @if (isLoading()) {
        <div class="d-flex justify-content-center align-items-center py-3">
          <mtm-loading-spinner [size]="24" />
        </div>
      } @else {
        <div class="dropdown-header">{{ headerLabel() }}</div>
        @for (option of options(); track option.value) {
          <button
            type="button"
            class="dropdown-item"
            [class.selected]="option.value === value()"
            (click)="select(option)">
            <svg
              class="flag-icon"
              width="8"
              height="9"
              viewBox="0 0 8 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M0.5625 0C0.873162 0 1.125 0.251838 1.125 0.5625V8.4375C1.125 8.74818 0.873162 9 0.5625 9C0.251838 9 0 8.74818 0 8.4375V0.5625C0 0.251838 0.251838 0 0.5625 0ZM2.25 0.794532C2.25019 0.444906 2.6316 0.229092 2.93142 0.408984L7.875 3.375L2.93142 6.34104C2.6316 6.52092 2.25019 6.3051 2.25 5.95548V0.794532Z"
                [attr.fill]="option.colorScheme.flag" />
            </svg>
            <span class="item-label" [style.color]="option.colorScheme.filterText">
              {{ translateLabel(option) }}
            </span>
            @if (option.value === value()) {
              <svg
                class="check-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path
                  d="M11.6663 3.5L5.24967 9.91667L2.33301 7"
                  stroke="#22c55e"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            }
          </button>
        }
      }
    </div>
  </ng-template>
</div>
